import React, { useEffect, useState } from 'react';
import Loader from '../components/Loader';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import BtnStandard from '../components/BtnStandard';

const CallBack = () => {



    const { aid, token_brand, session_pay, name } = useParams();

    const [success, setSuccess] = useState(false)
    const [error,setError]=useState(false)
    const [urlRedirect, setUrlRedirect] = useState("")
    const redirectSwitch = (urlRedirect) => {
        if (window.self !== window.top) {
            if(window?.top?.window?.top){
                window.parent.parent.postMessage({ urlRedirect: urlRedirect }, "*");
            }else{
                window.parent.postMessage({urlRedirect: urlRedirect }, "*");
            }
        } else {
            window.open(urlRedirect, '_blank');
        }
    }
    const init = async () => {
        if (aid && token_brand && name && session_pay) {

            const response = await axios.post(process.env.REACT_APP_API + '/pay_routes/success_route', { aid, token_brand, name, session_pay })
            if (response?.data) {
                if (response?.data?.status && response?.data?.urlRedirect) {
                    setSuccess(true)
                    setUrlRedirect(response.data.urlRedirect)
                    setTimeout(() => {
                        redirectSwitch(response.data.urlRedirect)
                    }, 3000);
                    return;
                } 
            }
        }
        setError(true)
    }

    const goBackPlatforme = () => {
        if (urlRedirect) {
            redirectSwitch(urlRedirect)
        }
    }

    useEffect(() => {
        init()
    }, [])

    return (
        <div className='page-h100 df aic jcc fdc tac cw fr'>
            {error&&(
                <>
                    <p className='fbb fs20 cw'>Une erreur est survenue</p>
                    <p className='fr cw'>Ne nous inquiéter pas si vous avez effectué votre paiement</p>
                    <p className='fr cw'>Votre commande sera traité</p>
                </>
            )}
            {success && (
                <>
                    <p className='fbb fs20 cw'>Merci pour votre commande</p>
                    <p className='fr cw'>Tout s'est bien déroulé, vous allez être redirigé vers la plateforme.</p>
                    <div className='mt2'>
                        <BtnStandard click={() => goBackPlatforme()} label={"Retourner sur la plateforme"} />
                    </div>
                    <p className='mt2 cw fr'>Vous pouvez fermer la page</p>
                </>
            )}
            {!success && (
                <>
                    <Loader />

                    <p className='fbb mt3'>Ne fermer pas la page</p>
                    <p className='fr'>Nous vérifions la session</p>
                    <p className='fr'>Redirection automatique en cours...</p>
                </>
            )}
        </div>
    );
};

export default CallBack;